
<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
      <div :class="[ tab === 'upload' ? 'active' : '' ]" @click="tab = 'upload'">Upload</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="ex-from" class="form-label">From currency *</label>
              <select class="form-control" id="ex-from" v-model="entity.fromCurrency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="ex-to" class="form-label">To currency *</label>
              <select class="form-control" id="ex-to" v-model="entity.toCurrency">
                <option value=""></option>
                <option v-for="(opt, i) in currencies" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="ex-rate" class="form-label">Exchange rate *</label>
              <input type="number" step="0.00001" class="form-control" id="ex-rate" v-model="entity.exchangeRate" @input="updateInverse"/>
            </div>
            <div class="form-group">
              <label for="in-rate" class="form-label">Inverse rate *</label>
              <input readonly type="number" step="0.00001" class="form-control" id="in-rate" v-model="entity.inverseRate"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="ex-from" class="form-label">Rate source</label>
              <select class="form-control" id="ex-from" v-model="entity.rateSource">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="ex-from" class="form-label">Rate type</label>
              <select class="form-control" id="ex-from" v-model="entity.rateType">
                <option value=""></option>
                <option v-for="(opt, i) in getSystemOptions('EXCHANGE_RATE_TYPE')" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="ex-desc" class="form-label">Description</label>
              <textarea class="form-control" id="ex-desc" rows="5" v-model="entity.description"></textarea>
            </div>
            <!--
              <div class="form-group">
                <label for="ex-up" class="form-label">Last update date</label>
                <input disabled type="text" class="form-control" id="ex-up" v-model="entity.lastUpdateDate"/>
              </div>
              <div class="form-group">
                <label for="ex-up-by" class="form-label">Last update by</label>
                <input disabled type="text" class="form-control" id="ex-up-by" v-model="entity.lastUpdateBy"/>
              </div>
            -->
          </div>
        </div>
        <div v-if="tab === 'upload'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="file" class="form-label">File</label>
              <input type="file" id="file" ref="file" class="form-control" @change="handleFileUpload()"/>
              <button class="btn" @click="upload()" :disabled="!file || uploading">Upload File</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  export default {
    name: 'ExchangeRate',
    mixins: [AdminEntityMixin, HelperMixin],
    data () {
      return {
        shouldUpdateCache: true,
        cachePropertyName: 'exchangeRates',
        transformForUpdate: {
          fromCurrency: this.toMinus,
          toCurrency: this.toMinus,
          rateType: this.toMinus,
          rateSource: this.toMinus,
          inverseRate: this.toZero,
          exchangeRate: this.toZero
        },
        editEntityScreen: 'Admin - Edit/View Exchange Rate',
        newEntityScreen: 'Admin - Exchange Rates',
        tab: 'main',
        boxes: [
          {
            prop: 'fromCurrency',
            id: 'id'
          },
          {
            prop: 'toCurrency',
            id: 'id'
          },
          {
            prop: 'rateType',
            id: 'id'
          },
          {
            prop: 'rateSource',
            id: 'id'
          }
        ],
        entity: {
          id: null,
          fromCurrency: null,
          toCurrency: null,
          rateType: null,
          exchangeRate: null,
          inverseRate: null,
          description: null,
          rateSource: null
        },
        preSaveEntity: null,
        entityName: 'exchange-rate',
        file: null,
        uploading: false
      }
    },
    computed: {
      isValid () {
        return this.entity.fromCurrency && this.entity.toCurrency && this.entity.inverseRate && this.entity.exchangeRate
      }
    },
    methods: {
      refresh () {
        if (this.entity.id) {
          this.preSaveEntity = {...this.entity}
        } else {
          this.preSaveEntity = {}
        }
      },
      postSaveRoutine (data) {
        return new Promise((resolve, reject) => {
          const exchangeRateHistory = {
            exchangeRate: { id: data.id },
            rateWas: this.preSaveEntity.exchangeRate,
            rateNow: data.exchangeRate,
            inverseWas: this.preSaveEntity.inverseRate,
            inverseNow: data.inverseRate,
            dateOfChange: data.lastUpdateDate,
            dateOfLastChange: this.preSaveEntity.lastUpdateDate
          }
          this.$http.post(API.CREATE_ADMIN_ENTITY('exchange-rate-history'), exchangeRateHistory).catch(console.log)
          resolve()
        })
      },
      updateInverse (e) {
        this.entity.inverseRate = 1 / parseFloat(e.target.value)
      },
      getBaseData () {
        return {
          id: null,
          fromCurrency: null,
          toCurrency: null,
          rateType: null,
          exchangeRate: null,
          inverseRate: null,
          description: null,
          rateSource: null
        }
      },
      handleFileUpload () {
        this.file = this.$refs.file.files[0]
      },
      upload () {
        this.uploading = true
        const data = new FormData()
        data.append('file', this.file)
        data.append('startImport', 'true')
        const headers = { 'Content-Type': 'multipart/form-data' }

        this.$http.post(API.EXCHANGE_RATE_FILE_UPLOAD, data, { headers })
          .then(({data}) => {
            event.$emit('toast', { type: 'success', message: 'File uploaded' })
          })
          .catch(err => {
            console.log(err)
            event.$emit('toast', { type: 'error', message: 'Upload failed' })
          })
          .finally(() => {
            this.file = null
            this.$refs.file.value = null
            this.uploading = false
          })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// ExchangeRate.vue?5ce1c557